<template>
  <div class="current-conditions-popup-wrap">
    <div class="name-header">
      <div class="marker-selected" @click="handleClickMarker">
        <whin-marker :width="27.25" :is-selected="true" :has-shadow="false" :is-highlighted="isHighlighted" ></whin-marker>
      </div>
      <div class="name">{{station.name}}</div>
    </div>
    <div class="time-header">{{ time.format_brief() }}</div>

    <div v-if="!hasData && !isLoggedIn">
      <div class="m-3 text-center" style="width: 150px; font-size: 1rem">This data is available to Alliance members.</div>
      <div class="text-center"><a data-toggle="modal" data-target="#login-modal"  class="button btn btn-primary text-white">Log In</a></div>
    </div>
    <div v-if="!hasData && isLoggedIn">
      <div class="m-3 text-center" style="width: 150px; font-size: 1rem">This station has not reported in the last two hours.</div>
    </div>
    <div v-if="hasData">
      <div class="temp"><span class="degrees">{{ temp.format_value() }}</span><span class="units" v-if="temp.is_valid()">{{temp.format_units()}}</span></div>

      <div class="flex-row main-panel">
        <div class="soil">
          <div class="vegetation"></div>
          <div class="depth depth-1">
            <div class="temp">{{ soil1_temp.format_value() }}</div>
            <div class="moist" :title="soil1_moist.format_detail()">
              <div v-if="soil1_moist.is_valid() === false">--</div>
              <moisture-drops v-else :width="27.5" :num-drops-filled="soil1_moist.get_num_drops()"></moisture-drops>
            </div>
          </div>
          <div class="depth depth-2">
            <div class="temp">{{ soil2_temp.format_value()  }}</div>
            <div class="moist"  :title="soil2_moist.format_detail()">
              <div v-if="soil2_moist.is_valid() === false">--</div>
              <moisture-drops v-else :width="27.5" :num-drops-filled="soil2_moist.get_num_drops()"></moisture-drops>
            </div>
          </div>
          <div class="depth depth-3">
            <div class="temp">{{ soil3_temp.format_value()  }}</div>
            <div class="moist"  :title="soil3_moist.format_detail()">
              <div v-if="soil3_moist.is_valid() === false">--</div>
              <moisture-drops v-else :width="27.5" :num-drops-filled="soil3_moist.get_num_drops()"></moisture-drops>
            </div>
          </div>
          <div class="depth depth-4">
            <div class="temp">{{ soil4_temp.format_value()  }}</div>
            <div class="moist" :title="soil4_moist.format_detail()">
              <div v-if="soil4_moist.is_valid() === false">--</div>
              <moisture-drops v-else :width="27.5" :num-drops-filled="soil4_moist.get_num_drops()"></moisture-drops>
            </div>
          </div>

        </div>

        <div class="metrics">
          <div class="rain flex-row" :title="rain.format_detail()">
            <div class="icon"></div>
            <div class="value">{{ rain.format_value() }}</div>
          </div>
          <div class="wind flex-row">
            <div class="icon"></div>
            <div class="value">{{ wind.format_direction() }} {{wind.format_value()}}<span class="superscript">{{wind.format_units()}}</span></div>
          </div>
          <div class="humidity flex-row">
            <div class="icon">H</div>
            <div class="value">{{ humidity.format_value() }}<span class="superscript" v-if="humidity.is_valid()">{{humidity.format_units()}}</span></div>
          </div>
          <div class="pressure flex-row">
            <div class="icon"></div>
            <div class="value">{{ pressure.format_value() }}<span class="superscript" v-if="pressure.is_valid()">{{pressure.format_units()}}</span></div>
          </div>
          <div class="solar-radiation flex-row" v-if="solar.is_valid()">
            <div class="icon"></div>
            <div class="value">{{ solar.format_value() }}<span class="superscript" v-if="solar.is_valid()" v-html="solar.format_units()"></span></div>
          </div>
        </div>

      </div>
    </div>

<!--    <div class="flex-row">-->
<!--      <button @click="handleViewDetails">Details</button>-->
<!--    </div>-->

  </div>
</template>

<script>
  import WHINTriangleMarker from './WHINTriangleMarker';
  import MoistureDrops from "@/components/MoistureDrops";
  import bus from '../bus';
  import WeatherStationObservationParser from '@/models';

  export default {
    name: "CurrentConditionsPopup",
    components: {
      'whin-marker': WHINTriangleMarker,
      'moisture-drops': MoistureDrops,
    },
    props: {
      station: Object,
      isLoggedIn: {type: Boolean, default: false, required: false},
      isHighlighted: {
        type: Boolean,
        default: false,
        required: false,
      },
    },
    computed: {
      hasData() {
        // Data will have a time
        return this.station.observation_time !== undefined;
      },
      station_data() {
        return new WeatherStationObservationParser(this.station);
      },

      time() {
        return this.station_data.parse_observation_time();
      },
      temp() {
        return this.station_data.parse_current_temperature();
      },
      rain() {
        return this.station_data.parse_current_rain();
      },
      wind() {
        return this.station_data.parse_current_wind();
      },
      humidity() {
        return this.station_data.parse_current_humidity();
      },
      pressure() {
        return this.station_data.parse_current_pressure();
      },
      solar() {
        return this.station_data.parse_current_solar();
      },
      soil1_temp() {
        return this.station_data.parse_soil_temp(1);
      },
      soil1_moist() {
        return this.station_data.parse_soil_moist(1);
      },
      soil2_temp() {
        return this.station_data.parse_soil_temp(2);
      },
      soil2_moist() {
        return this.station_data.parse_soil_moist(2);
      },
      soil3_temp() {
        return this.station_data.parse_soil_temp(3);
      },
      soil3_moist() {
        return this.station_data.parse_soil_moist(3);
      },
      soil4_temp() {
        return this.station_data.parse_soil_temp(4);
      },
      soil4_moist() {
        return this.station_data.parse_soil_moist(4);
      }
    },

    methods: {
      handleViewDetails() {
        bus.$emit("view-station-details", {station_id: this.station.id});

      },
      handleClickMarker() {
        bus.$emit("close-popup", {station_id: this.station.id});
      },
      handleClickLogin() {
        bus.$emit("show-login-modal");
      }
    }

  }
</script>

<style scoped>
  .current-conditions-popup-wrap {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    text-align: left;

    user-select: none;

    min-width: 188px;
    max-width: 238px;
    min-height: 214px;

    position: absolute;

    background: transparent radial-gradient(farthest-corner at 0% 5%, #FFFFFF 0%, #FFFFFF 22%, #D6FFFC 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0 3px 4px #00000073;
  }

  .marker-selected {
    position: absolute;
    top: -1px;
    left: -11px;
    width: 18px;
    height: 14px;
  }

  .superscript {
    vertical-align: text-top;
    font-size: 10px;
    font-weight: 600;
  }

  .name-header {
    width: 100%;
    background-color: #00BFB0;
    color: white;

  }

  .time-header {
    background: rgba(0, 191, 176, .33) 0% 0% no-repeat padding-box;

    color: rgba(0, 0, 0, .5);
    font-size: 12px;
    font-weight: 600;
    text-align: center;
  }

  .name {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin-left: 17px;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
  }

  .temp {
    width: 100%;

    text-align: center;

  }

  .degrees {
    font-size: 42px;
    /* temp is centered, but want the degrees symbol and units to not count */
    margin-left: 14px;
  }
  .temp .units {
    font-size: 15px;
    position: relative;
    left: -12px;
    font-weight: 600;
  }

  .flex-row {
    display: flex;
  }

  .main-panel {
    padding: 2px 7px;
  }

  .metrics {
    flex: 0 0 auto;

    margin-top: 3px;
    margin-left: 7px;

    min-width: 78px;
  }

  .metrics .flex-row {
    display: flex;
    flex-direction: row;
    margin-top: 2px;

    line-height: 19px;
  }
  .metrics .flex-row .icon {

    flex: 0 0 auto;

    width: 17px;
    height: 17px;
    margin: 4px 6px 0 0;
  }

  .metrics .flex-row.rain .icon {
    background: transparent url('../icons/raindrops.svg') 0% 0% no-repeat padding-box;
    background-size: contain;

    width: 17px;
    height: 18px;

    margin: 1px 6px 0 0;
  }

  .metrics .flex-row.wind .icon {
    background: transparent url('../icons/wind.svg') 0% 0% no-repeat padding-box;
    background-size: contain;
    width: 18px;
    height: 18px;

    margin: 4px 5px 0 0;
  }

  .metrics .flex-row.humidity .icon {
    text-align: center;
    width: 17px;
    line-height: 18px;
    margin: 3px 6px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: #00BFB0;
  }

  .metrics .flex-row.pressure .icon {
    background: transparent url('../icons/gauge-solid.svg') 0% 0% no-repeat padding-box;
    background-size: contain;
    width: 17px;
    height: 18px;

    margin: 4px 6px 0 0;
  }

  .metrics .flex-row.solar-radiation .icon {
    background: transparent url('../icons/sun.svg') 0% 0% no-repeat padding-box;
    background-size: contain;
    width: 18px;
    height: 18px;
    margin: 3px 5px 0 0;
  }

  .metrics .flex-row .value {
    flex: 1 0 auto;

    font-size: 18px;
    font-weight: 600;

  }

  .soil {
    flex: 0 1 auto;

    width: 66px;
  }

  .soil .vegetation {
    width: 66px;
    height: 12px;

    background: transparent url("../icons/greenery.svg") 0 0 no-repeat padding-box;
    background-size: cover;

    /* Pull up the soil by 1px */
    margin-bottom: -1px;
  }

  .soil .depth {
    display: flex;
    height: 28px;
  }

  .soil .depth.depth-1 {
    background-color: #AA846F;
  }
  .soil .depth.depth-2 {
    background-color: #98715B;
  }
  .soil .depth.depth-3 {
    background-color: #835E49;
  }
  .soil .depth.depth-4 {
    background-color: #684A39;
  }

  .soil .depth .temp {
    font-size: 15px;
    font-weight: 700;
    color: white;
    width: 18px;
    text-align: center;
    margin: 3px 0 0 5px;
  }
  .soil .depth .moist {
    font-size: 15px;
    font-weight: bold;
    color: #51FFF1;
    width: 44px;
    text-align: center;
    margin: 2px 0 0 2px;
  }

  button {
    flex: 1 0 auto;

    width: 138px;
    height: 28px;
    margin: 6px;
    font-size: 15px;
    font-weight: 600;
    color: white;
    background: #00BFB0 0% 0% no-repeat padding-box;
    outline: none;
  }

</style>